import { styled } from '@mui/material';

import { STYLED_ANIMATIONS } from '../../utils/animations.utils';
import { Icon } from '../icon/icon.component';

export const StyledLoadingIndicatorIcon = styled(Icon)({
	animation: `${STYLED_ANIMATIONS['gyant-animation-spin']} 1s linear infinite`,
});
